<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Facturas</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Facturas</h6>
    </table>


    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="container-fluid mt-4">

    <div class="row align-items-center">

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="mat-table-pedidos">
                <table mat-table matTableResponsive [dataSource]="dataSource" matSort #matSort="matSort"
                    matSortActive="nroPedido" matSortDirection="desc">


                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                        <td mat-cell *matCellDef="let f">
                            <div>

                                <button (click)="seleccionar(f)" matTooltip="Seleccionar"
                                    mat-icon-button color="primary-darker">
                                    <mat-icon color="accent-darker">done</mat-icon>
                                </button>

                            </div>

                        </td>
                    </ng-container>



                    <ng-container matColumnDef="nroFactura">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroFactura}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.nroFactura}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>
                    <ng-container matColumnDef="nroPedido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroPedido}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.nroPedido}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>
                    <ng-container matColumnDef="nroRemito">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroRemito}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.nroRemito}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaVencimiento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.FechaVencimiento}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.fechaVencimiento}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>


                    <ng-container matColumnDef="totalFactura">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.TotalFactura}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.totalFactura | number : '1.2-2'}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="idZonaVendedor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdZonaVendedor}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.idZonaVendedor}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="tipoOrden">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.TipoOrden}}
                        </th>
                        <td mat-cell *matCellDef="let f">
                            {{f.tipoOrden}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>



                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let f; columns: displayedColumns;">
                    </tr>

                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            {{Etiquetas.SinRegistros}}
                        </td>
                    </tr>
                </table>

                <mat-paginator #matPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>